import React from 'react';
import {Layout, Typography} from 'antd';

const {Footer} = Layout;
const {Text} = Typography;

/**
 * CustomerFooter Component
 *
 * Renders the footer area of the application.
 */
const CustomerFooter: React.FC = () => {

    return (
        <Footer className="app-footer">
            <Text>
                一帆科技有限公司 版權所有 © 2025
            </Text>
        </Footer>
    );
};

export default CustomerFooter;
